import { useEffect, useRef } from 'react'
import TagManager from 'react-gtm-module'
import { useLocation } from 'react-router-dom'

function useGTM() {
  const { pathname } = useLocation()
  const isInitialized = useRef(false)

  useEffect(() => {
    if (isInitialized.current) return

    let gtmId ="GTM-N8LQSVFS"

    if (pathname === '/create-ai-hentai') {
      gtmId = 'GTM-T7KC2FRG'
    } else if (pathname.includes('/ndg')) {
      gtmId = 'GTM-PCK2G95G'
    }

    TagManager.initialize({ gtmId })
    isInitialized.current = true
  }, [pathname])
}

export default useGTM
